import api from './axiosNew';

export const getReportCatalog = () => api.get('/api/reports/catalog');

export const getTimeEntrySummary = (params) => api.get('/api/reports/time-entry-summary', { params });

export const getProductionTaskReport = (params) => api.get('/api/reports/production-task', { params });

export const getTeamPerformanceReport = (params) => api.get('/api/reports/team-performance', { params });

export const getTaskAssignmentReport = (params) => api.get('/api/reports/task-assignment', { params });

export const getSyncHealthReport = (params) => api.get('/api/reports/sync-health', { params });

export const getPersonalInsightsReport = (params) =>
  api.get('/api/reports/personal-insights', { params });

export const getLeadershipInsightsReport = (params) =>
  api.get('/api/reports/leadership-insights', { params });

export const exportReportCsv = (reportKey, params) =>
  api.get(`/api/reports/export/${reportKey}`, { params, responseType: 'blob' });
